import { createReducer, MetaReducer, on } from '@ngrx/store';
import { IStatistic } from '../../../../model/statistics';
import StatisticsActions from './statistics.action-types';

export const statisticsFeatureKey = 'statistics';

export interface StatisticsState {
    statistics: IStatistic[];
}

export const initialStatisticsState: StatisticsState = {
    statistics: []
};

export const metaReducers: MetaReducer<StatisticsState>[] = [];

export const statisticsContextReducer = createReducer(
    initialStatisticsState,

    // Links
    on(StatisticsActions.loadStatistics, (state, action) => {
        return {
            statistics: action.statistics
        };
    })
);
